export enum ViewMode {
  RICH_TEXT = 'rich_text',
  PLAIN_TEXT = 'plain_text',
}

export enum BlockType {
  PARAGRAPH = 'paragraph',
  H1 = 'h1',
  H2 = 'h2',
  QUOTE = 'quote',
  UL = 'ul',
  OL = 'ol',
  CODE = 'code',
}
